export default __webpack_public_path__ + "static/media/TV_Brasil.93a0e527.png";